import { render, staticRenderFns } from "./SaveAsTemplateModal.vue?vue&type=template&id=65cdfe07&scoped=true"
import script from "./SaveAsTemplateModal.vue?vue&type=script&lang=js"
export * from "./SaveAsTemplateModal.vue?vue&type=script&lang=js"
import style0 from "./SaveAsTemplateModal.vue?vue&type=style&index=0&id=65cdfe07&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65cdfe07",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65cdfe07')) {
      api.createRecord('65cdfe07', component.options)
    } else {
      api.reload('65cdfe07', component.options)
    }
    module.hot.accept("./SaveAsTemplateModal.vue?vue&type=template&id=65cdfe07&scoped=true", function () {
      api.rerender('65cdfe07', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/layouts-page/modals/design-gallery/SaveAsTemplateModal.vue"
export default component.exports